/* eslint-disable react/prop-types,no-underscore-dangle,max-len */
import React from 'react';
import PropTypes from 'prop-types';
// formik
import { Formik } from 'formik';
import * as Yup from 'yup';
// @material-ui/icons
import Lock from '@material-ui/icons/Lock';
import Email from '@material-ui/icons/Email';
import Phone from '@material-ui/icons/Phone';
import Trash from '@material-ui/icons/Delete';
import Fullname from '@material-ui/icons/Person';
// @material-ui/core components
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
import Check from '@material-ui/icons/Check';
import Checkbox from '@material-ui/core/Checkbox';
import Select from '@material-ui/core/Select/Select';
import MenuItem from '@material-ui/core/MenuItem/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// core components
import Card from 'components/UI/Card/Card';
import GridItem from 'components/UI/Grid/GridItem';
import CardBody from 'components/UI/Card/CardBody';
import Button from 'components/UI/CustomButtons/Button';
import Snackbars from 'components/UI/Snackbar/Snackbar';
import GridContainer from 'components/UI/Grid/GridContainer';
import CustomInput from 'components/UI/CustomInput/CustomInput';
// global variables
import {
  userRanks,
  userKinds,
  leads,
  agencyPaymentMethod,
  cardProvider,
} from 'config';
// our components
import { USER } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import Avatar from 'components/common/Avatar/Avatar';
import ModalConfirmation from 'components/common/ModalConfirmation';
import Loading from 'components/common/Loading';
import WithPermission from 'components/User/WithPermission';
import { withTranslation } from 'react-i18next';
import TagsInput from 'react-tagsinput';
import agencyPaymentMethodTextHelper from 'helpers/agencyPaymentMethodTextHelper';
import { getUserPhotoUrl } from 'helpers/functions';

/**
 * Validation form's rules
 */
const validationSchema = Yup.object({
  fullname: Yup.string('Este campo debe tener valor').required(
    'Debe insertar su nombre.',
  ),
  email: Yup.string('Correo')
    .email('Inserte una dirección válida. Ej. nombre@correo.com')
    .when('phone', {
      is: value => !value,
      then: Yup.string('Enter your email').required(
        'Este campo es requerido si no inserta un ' +
          'número de teléfono en el campo siguiente.',
      ),
    }),
  phone: Yup.number('Enter your phone'),
  password1: Yup.string('').min(
    6,
    'La contraseña debe contener al menos 6 caracteres.',
  ),
  password2: Yup.string('Enter your password').when('password1', {
    is: value => !!value,
    then: Yup.string('Enter your password')
      .required('Confirm your password')
      .oneOf([Yup.ref('password1')], 'Las contraseñas no coinciden.'),
  }),
  rank: Yup.string('Este campo debe de tener valor').required(
    'user type requerido',
  ),
  commissionLead: Yup.number().when('userType', {
    is: userKinds.AGENCY,
    then: Yup.number().required('This field is required'),
  }),
  commissionLeadRevolico: Yup.number().when('userType', {
    is: userKinds.AGENCY,
    then: Yup.number().required('This field is required'),
  }),
});

/**
 * @class
 * @extends React.Component
 */
class UserUpdate extends React.Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      userData:
        props.userData && props.userData.adminUser
          ? {
              ...props.userData.adminUser,
              email:
                props.userData.adminUser.email !== null
                  ? props.userData.adminUser.email
                  : '',
              phone:
                props.userData.adminUser.phone !== null
                  ? props.userData.adminUser.phone
                  : '',
              password1: '',
              password2: '',
              commissionLead:
                props.userData.adminUser.commissionLead !== null
                  ? props.userData.adminUser.commissionLead
                  : '',
              commissionLeadRevolico:
                props.userData.adminUser.commissionLeadRevolico !== null
                  ? props.userData.adminUser.commissionLeadRevolico
                  : '',
              allowedIps:
                props.userData.adminUser.allowedIps !== null
                  ? props.userData.adminUser.allowedIps
                  : [],
              negativeCredit:
                props.userData.adminUser.negativeCredit !== null
                  ? props.userData.adminUser.negativeCredit
                  : false,
              paymentMethod:
                props.userData.adminUser.paymentMethod !== null
                  ? props.userData.adminUser.paymentMethod
                  : agencyPaymentMethod.CASH,
              cardProvider: props.userData.adminUser.cardProvider || 'A_',
              photo:
                props.userData.adminUser.photo &&
                props.userData.adminUser.photo.gcsKey,
            }
          : {},
      uploadPending: false,
      showDeleteUser: false,
    };
    this.photoRef = null;
    this.formikRef = null;
  }

  /**
   * @description
   * Handle redirect when cancel update User.
   */
  handleCancelUpdate = () => {
    const history = this.context;
    history.push(USER.LIST);
  };

  /**
   * @description
   * Handle submit exec userUpdate callback when finish upload image.
   */
  handleSubmit = () => {
    const { userData, uploadPending } = this.state;
    const { userUpdate } = this.props;

    // if the image is pending to upload send it
    if (uploadPending) {
      this.photoRef.uploadFile();
    } else {
      // else call the form callback
      const isUserAgency = userData.userType === userKinds.USER_AGENCY;
      const updateData = { ...userData };
      if (isUserAgency) {
        delete updateData.leadAgency;
        delete updateData.password1;
        delete updateData.password2;
        delete updateData.commissionLead;
        delete updateData.commissionLeadRevolico;
        delete updateData.paymentMethod;
      }

      userUpdate(updateData);
    }
  };

  /**
   * @description
   * Photo image changed. This method will be called when an Photo
   * image change locally.
   *
   * @param {string} imageUrl - New image url.
   */
  handleImageChange = imageUrl => {
    const { userData } = this.state;
    const uploadPending = !!imageUrl;
    this.setState({
      uploadPending,
      userData: { ...userData, photo: imageUrl },
    });
  };

  /**
   * @description
   * Photo image uploaded successfully callback.
   *
   * @param {string} imageKey - Image gcs_key.
   */
  handleUploadComplete = imageKey => {
    const { userData } = this.state;
    const { userUpdate } = this.props;
    this.setState({
      uploadPending: false,
      userData: { ...userData, photo: imageKey },
    });
    userUpdate({ ...userData, photo: imageKey });
  };

  /**
   * @description
   * Set server errors with Formik setErrors function.
   *
   * @param {Array} serverErrors - Api errors.
   * @returns {Object} Global form's errors.
   */
  setServerErrors = serverErrors => {
    let all = null;
    if (this.formikRef && serverErrors.length) {
      const errors = {};

      serverErrors.forEach(item => {
        errors[item.field] = item.messages;
        if (item.field === '__all__') {
          all = item.messages;
        }
      });

      setTimeout(() => this.formikRef && this.formikRef.setErrors(errors), 0);
    }
    return all;
  };

  /**
   * @description
   * Close modal.
   */
  handleCloseModal = () => {
    const { showDeleteUser } = this.state;
    this.setState({ showDeleteUser: !showDeleteUser });
  };

  /**
   * @description
   * To show modal.
   */
  handleShowDeleteConfirmation = () => {
    const { showDeleteUser } = this.state;
    this.setState({ showDeleteUser: !showDeleteUser });
  };

  /**
   * @description
   * Map userType to specific strings.
   *
   * @param {string} userType - User type.
   * @param {string} action - Action.
   * @returns {string} Mapped user types.
   */
  handleMapPermissions = (userType, action) => {
    if (userType === userKinds.USER_AGENCY)
      return [`${action}_useragency`, `${action}_ownership_useragency`];
    if (userType === userKinds.AGENCY) return [`${action}_agency`];
    if (userType === userKinds.USER) return [`${action}_user`];
    return [];
  };

  /**
   * @description
   * Render Update User form using Formik.
   *
   * @returns {*} Update User component.
   */
  render() {
    const {
      classes,
      errors: serverErrors,
      userDelete,
      submitLoading,
      t,
    } = this.props;
    const { userData, showDeleteUser } = this.state;
    const isAgency = userData.userType === userKinds.AGENCY;
    const isUserAgency = userData.userType === userKinds.USER_AGENCY;
    const all = this.setServerErrors(serverErrors);
    return (
      <React.Fragment>
        <Snackbars place="tc" message={all || ''} open={!!all} color="danger" />
        <ModalConfirmation
          show={showDeleteUser}
          confirm={userDelete}
          cancel={() => this.handleCloseModal()}
          title={t('user.details.modal.question')}
          description={userData.fullname}
          confirmLabel={t('user.details.modal.ok')}
        />

        <Formik
          ref={ref => {
            this.formikRef = ref;
          }}
          initialValues={{ ...userData }}
          validationSchema={validationSchema}
          onSubmit={values => {
            this.setState({
              userData: {
                ...userData,
                ...values,
                photo: userData.photo,
              },
            });
            this.handleSubmit();
          }}
          render={({
            values,
            errors,
            touched,
            handleChange,
            handleSubmit,
            handleBlur,
          }) => (
            <div>
              <GridContainer justify="space-between" alignItems="center">
                <GridItem>
                  <h3 className={classes.title}>{t('user.update.title')}</h3>
                </GridItem>
                <GridItem>
                  <WithPermission
                    allowPermissions={this.handleMapPermissions(
                      userData.userType,
                      'delete',
                    )}
                  >
                    <Button
                      id="user-update-button-delete"
                      color="danger"
                      simple
                      block
                      disabled={submitLoading}
                      onClick={this.handleShowDeleteConfirmation}
                      className={classes.eraseUserBtn}
                    >
                      <Trash />
                      {t('user.update.erase')}
                    </Button>
                  </WithPermission>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12}>
                  <form onSubmit={handleSubmit} autoComplete="off">
                    <Card style={{ margin: '16px 0 0' }}>
                      <CardBody>
                        <Loading show={submitLoading} />
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={5}>
                            <div className={classes.editUserFormContainer}>
                              <Avatar
                                imageUrl={
                                  !userData.photo ||
                                  (userData.photo &&
                                    userData.photo.includes('data:image'))
                                    ? userData.photo
                                    : getUserPhotoUrl(userData.photo)
                                }
                                imageType="USER_IMAGE"
                                avatar
                                userType={userData.userType}
                                uploadComplete={this.handleUploadComplete}
                                imageChange={this.handleImageChange}
                                onRef={ref => {
                                  this.photoRef = ref;
                                }}
                              />
                            </div>
                          </GridItem>
                          <GridItem xs={12} sm={12} md={7}>
                            <div className={classes.editUserFormContainer}>
                              <CustomInput
                                labelText={t('user.create.name')}
                                id="fullname"
                                helpText={
                                  touched.fullname ? errors.fullname : ''
                                }
                                error={
                                  touched.fullname && Boolean(errors.fullname)
                                }
                                inputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Fullname
                                        className={classes.inputAdornmentIcon}
                                      />
                                    </InputAdornment>
                                  ),
                                  value: values.fullname,
                                  onChange: e => {
                                    handleChange(e);
                                  },
                                  onBlur: handleBlur,
                                  type: 'text',
                                  default: values.fullname,
                                }}
                              />

                              <CustomInput
                                labelText={t('user.create.email')}
                                id="email"
                                helpText={touched.email ? errors.email : ''}
                                error={touched.email && Boolean(errors.email)}
                                inputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Email
                                        className={classes.inputAdornmentIcon}
                                      />
                                    </InputAdornment>
                                  ),
                                  value:
                                    values.email !== null ? values.email : '',
                                  onChange: e => {
                                    handleChange(e);
                                  },
                                  onBlur: handleBlur,
                                  type: 'email',
                                  default: values.email,
                                }}
                              />

                              <CustomInput
                                labelText={t('user.create.phone')}
                                id="phone"
                                helpText={touched.phone ? errors.phone : ''}
                                error={touched.phone && Boolean(errors.phone)}
                                inputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      <Phone
                                        className={classes.inputAdornmentIcon}
                                      />
                                    </InputAdornment>
                                  ),
                                  value:
                                    values.phone !== null ? values.phone : '',
                                  onChange: e => {
                                    handleChange(e);
                                  },
                                  onBlur: handleBlur,
                                  default: values.phone,
                                }}
                              />
                              {!isUserAgency && (
                                <GridContainer>
                                  <GridItem xs={12} sm={6} md={12} lg={6}>
                                    <CustomInput
                                      labelText={t('common.pass.title')}
                                      id="password1"
                                      helpText={
                                        touched.password1
                                          ? errors.password1
                                          : ''
                                      }
                                      error={
                                        touched.password1 &&
                                        Boolean(errors.password1)
                                      }
                                      inputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Lock
                                              className={
                                                classes.inputAdornmentIcon
                                              }
                                            />
                                          </InputAdornment>
                                        ),
                                        value: values.password1,
                                        onChange: e => {
                                          handleChange(e);
                                        },
                                        onBlur: handleBlur,
                                        type: 'password',
                                        default: values.password1,
                                      }}
                                    />
                                  </GridItem>
                                  <GridItem xs={12} sm={6} md={12} lg={6}>
                                    <CustomInput
                                      labelText={t('common.pass.confirm')}
                                      id="password2"
                                      helpText={
                                        touched.password2
                                          ? errors.password2
                                          : ''
                                      }
                                      error={
                                        touched.password2 &&
                                        Boolean(errors.password2)
                                      }
                                      inputProps={{
                                        endAdornment: (
                                          <InputAdornment position="end">
                                            <Lock
                                              className={
                                                classes.inputAdornmentIcon
                                              }
                                            />
                                          </InputAdornment>
                                        ),
                                        value: values.password2,
                                        onChange: e => {
                                          handleChange(e);
                                        },
                                        onBlur: handleBlur,
                                        type: 'password',
                                        default: values.password2,
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                              )}

                              {isAgency && (
                                <GridContainer>
                                  <GridItem xs={6}>
                                    <CustomInput
                                      labelText={t(
                                        'user.create.agency.commission.agency',
                                      )}
                                      id="commissionLead"
                                      formControlProps={{
                                        fullWidth: true,
                                      }}
                                      helpText={
                                        touched.commissionLead
                                          ? errors.commissionLead
                                          : ''
                                      }
                                      error={
                                        touched.commissionLead &&
                                        Boolean(errors.commissionLead)
                                      }
                                      inputProps={{
                                        value: values.commissionLead,
                                        onChange: e => {
                                          handleChange(e);
                                        },
                                        onBlur: handleBlur,
                                      }}
                                    />
                                  </GridItem>
                                  <GridItem xs={6}>
                                    <CustomInput
                                      labelText={t(
                                        'user.create.agency.commission.revolico',
                                      )}
                                      id="commissionLeadRevolico"
                                      formControlProps={{
                                        fullWidth: true,
                                      }}
                                      helpText={
                                        touched.commissionLeadRevolico
                                          ? errors.commissionLeadRevolico
                                          : ''
                                      }
                                      error={
                                        touched.commissionLeadRevolico &&
                                        Boolean(errors.commissionLeadRevolico)
                                      }
                                      inputProps={{
                                        value: values.commissionLeadRevolico,
                                        onChange: e => {
                                          handleChange(e);
                                        },
                                        onBlur: handleBlur,
                                      }}
                                    />
                                  </GridItem>
                                  <FormControl
                                    fullWidth
                                    className={classes.userSelect}
                                  >
                                    <h6>
                                      {t(
                                        'user.create.agency.payment_method.title',
                                      )}
                                    </h6>
                                    <GridContainer>
                                      {Object.keys(agencyPaymentMethod).map(
                                        key => (
                                          <GridItem xs={6}>
                                            <Button
                                              data-cy="agencyPaymentMethod"
                                              color="info"
                                              round
                                              simple={
                                                values.paymentMethod !== key
                                              }
                                              onClick={() =>
                                                handleChange({
                                                  target: {
                                                    name: 'paymentMethod',
                                                    value: key,
                                                  },
                                                })
                                              }
                                              id={`agency-payment-method-${key}`}
                                              fullWidth
                                            >
                                              {agencyPaymentMethodTextHelper(
                                                key,
                                                t,
                                              )}
                                            </Button>
                                          </GridItem>
                                        ),
                                      )}
                                    </GridContainer>
                                  </FormControl>
                                </GridContainer>
                              )}
                              {!isUserAgency ? (
                                <FormControl
                                  fullWidth
                                  className={classes.userSelect}
                                >
                                  <h6>{t('user.create.user_type')}</h6>
                                  <Select
                                    id="rank"
                                    MenuProps={{
                                      className: classes.selectMenu,
                                    }}
                                    classes={{
                                      select: classes.select,
                                    }}
                                    name="rank"
                                    onChange={handleChange}
                                    value={values.rank}
                                    className={classes.reviewDD}
                                  >
                                    {Object.keys(userRanks).map(key => {
                                      const labels = {
                                        STAFF: 'Staff',
                                        ADMIN: 'Super Admin',
                                        USER: 'Usuario',
                                      };
                                      return (
                                        <MenuItem
                                          key={key}
                                          classes={{
                                            root: classes.selectMenuItem,
                                            selected:
                                              classes.selectMenuItemSelected,
                                          }}
                                          value={userRanks[key]}
                                        >
                                          {labels[key]}
                                        </MenuItem>
                                      );
                                    })}
                                  </Select>
                                </FormControl>
                              ) : (
                                <FormControl
                                  fullWidth
                                  className={classes.userSelect}
                                >
                                  <h6> {t('userAgency.lead')} </h6>
                                  <GridContainer>
                                    <GridItem xs={12} sm={6}>
                                      <Button
                                        data-cy="sellerLead"
                                        id="seller-lead"
                                        name="sellerLead"
                                        simple={values.lead !== leads.SELLER}
                                        round
                                        fullWidth
                                        color="info"
                                        onClick={evt => {
                                          const targetEvent = {
                                            ...evt,
                                            target: {
                                              ...evt.target,
                                              id: 'lead',
                                              value: leads.SELLER,
                                            },
                                          };
                                          handleChange(targetEvent);
                                        }}
                                      >
                                        {userData.leadAgency.fullname}
                                      </Button>
                                    </GridItem>
                                    <GridItem xs={12} sm={6}>
                                      {' '}
                                      <Button
                                        data-cy="revoLead"
                                        id="revo-lead"
                                        name="revoLead"
                                        simple={values.lead !== leads.REVOLICO}
                                        round
                                        fullWidth
                                        color="info"
                                        onClick={evt => {
                                          const targetEvent = {
                                            ...evt,
                                            target: {
                                              ...evt.target,
                                              id: 'lead',
                                              value: leads.REVOLICO,
                                            },
                                          };
                                          handleChange(targetEvent);
                                        }}
                                      >
                                        Revolico
                                      </Button>
                                    </GridItem>
                                  </GridContainer>
                                </FormControl>
                              )}

                              <WithPermission
                                allowPermissions={['change_card_provider']}
                              >
                                <FormControl
                                  fullWidth
                                  className={classes.userSelect}
                                  style={{ marginTop: '24px' }}
                                >
                                  <h6>
                                    {t('user.create.card_provider.title')}
                                  </h6>
                                  <Select
                                    id="card_provider"
                                    MenuProps={{
                                      className: classes.selectMenu,
                                    }}
                                    classes={{
                                      select: classes.select,
                                    }}
                                    name="cardProvider"
                                    onChange={handleChange}
                                    value={values.cardProvider}
                                    className={classes.reviewDD}
                                  >
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                        selected:
                                          classes.selectMenuItemSelected,
                                      }}
                                      value="A_"
                                    >
                                      {t(
                                        'user.create.card_provider.without_card_provider',
                                      )}
                                    </MenuItem>
                                    {Object.keys(cardProvider).map(key => (
                                      <MenuItem
                                        key={key}
                                        classes={{
                                          root: classes.selectMenuItem,
                                          selected:
                                            classes.selectMenuItemSelected,
                                        }}
                                        value={cardProvider[key]}
                                      >
                                        {key}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </WithPermission>

                              <WithPermission allowPermissions={[]}>
                                <div className={classes.tagsInput}>
                                  <h6>{t('user.create.allowed_ip')}</h6>
                                  <TagsInput
                                    value={values.allowedIps}
                                    onlyUnique
                                    onChange={ipAddress =>
                                      handleChange({
                                        target: {
                                          name: 'allowedIps',
                                          value: ipAddress,
                                        },
                                      })
                                    }
                                    tagProps={{
                                      className: 'react-tagsinput-tag info',
                                    }}
                                    inputProps={{
                                      placeholder: t(
                                        'user.create.allowed_ip_placeholder',
                                      ),
                                    }}
                                  />
                                </div>
                              </WithPermission>
                              <WithPermission
                                allowPermissions={['change_negative_credit']}
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      data-cy="negativeCredit"
                                      id="negativeCredit"
                                      tabIndex={-1}
                                      onClick={handleChange}
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      classes={{
                                        checked: classes.checked,
                                      }}
                                      checked={values.negativeCredit}
                                    />
                                  }
                                  label={t(
                                    'user.create.checkbox_negative_credit',
                                  )}
                                />
                              </WithPermission>
                            </div>
                          </GridItem>
                        </GridContainer>

                        <GridContainer direction="row-reverse">
                          <GridItem xs={12} sm={6}>
                            <Button
                              data-cy="updateUser"
                              id="user-update-button-save"
                              type="submit"
                              color="primary"
                              className={classes.saveChangesbtn}
                            >
                              {t('ad.form.edit_btn')}
                            </Button>
                          </GridItem>

                          <GridItem xs={12} sm={6}>
                            <Button
                              id="user-update-button-cancel"
                              color="danger"
                              simple
                              onClick={this.handleCancelUpdate}
                            >
                              {t('common.cancel')}
                            </Button>
                          </GridItem>
                        </GridContainer>
                      </CardBody>
                    </Card>
                  </form>
                </GridItem>
              </GridContainer>
            </div>
          )}
        />
      </React.Fragment>
    );
  }
}

/**
 * UserUpdate PropTypes
 * @param classes - classes passed by withStyle HOC
 * @param userData - the data of the target User
 * @param errors - validation errors received from API
 * @param submitLoading - To change to loading status
 * @param t - prop from HOC with string translations
 * @callback userUpdate - callback to save changed data
 * @callback userDelete - callback to delete user
 */
UserUpdate.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  errors: PropTypes.instanceOf(Array).isRequired,
  userData: PropTypes.shape({}).isRequired,
  submitLoading: PropTypes.bool.isRequired,
  userUpdate: PropTypes.func.isRequired,
  userDelete: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

// to fix: The withStyles HOC set contextTypes to a children component
// and it have problem with contextType assigned to PermissionList component
// This is a small hack, with intermediary Component to resolved it temporally
const UserUpdateWrapper = props => <UserUpdate {...props} />;

export default withTranslation()(
  withStyles(validationFormsStyle)(UserUpdateWrapper),
);
